<template>
  <div id="notice">
      <yy-header>预约须知</yy-header>
      <div class="main">
        <ul class="content">
          <li>1、预约后不到现场取号/现场取号后不到窗口办理，都属于爽约行为。</li>
          <li>2、预约后不到现场取号/现场取号后不到窗口办理，都属于爽约行为。</li>
          <li>3、预约后不到现场取号/现场取号后不到窗口办理，都属于爽约行为。</li>
        </ul>
      </div>
      <footer class="reservation-foot">
        <span @click="back" class="reservation-btn">我已知悉，开始预约</span>
      </footer>
    </div>
</template>

<script>
export default {
  data () {
    return {

    }
  },
  methods: {
    back () {
      window.history.back()
    },
    onClickRight () {

    }
  }
}
</script>

<style lang="less" scoped>
#notice {
  .content {
    margin: .4rem /* 20/50 */;
    padding: .76rem /* 38/50 */;
    background-color: #fff;
    border-radius: 5px;
    font-size: .6rem /* 30/50 */;
    color: #555555;
    line-height: .92rem /* 46/50 */;
    li {
      margin-top: .76rem /* 38/50 */;
      &:first-child {
        margin-top: 0;
      }
    }
  }
}
</style>
